// extracted by mini-css-extract-plugin
export default {"container":"miniFooter_container__7YL1d","logo":"miniFooter_logo__+2QsV","actions":"miniFooter_actions__dvGqo","action":"miniFooter_action__3rX35"};